// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.group[data-v-ab722b66] {\n  margin: 1rem 0 1rem 1rem;\n}\n.error[data-v-ab722b66] {\n  color: var(--danger);\n}\n", ""]);
// Exports
module.exports = exports;
